export default "__VITE_ASSET__Da_Igsvd__"